import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=756cbb1a&scoped=true&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=756cbb1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756cbb1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('756cbb1a')) {
      api.createRecord('756cbb1a', component.options)
    } else {
      api.reload('756cbb1a', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=756cbb1a&scoped=true&", function () {
      api.rerender('756cbb1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Checkbox.vue"
export default component.exports